import { useEffect, useState } from "react";

import Column from "./Column";
interface IProps {
	data: any[];
	columnClassName?: string;
	columnsData: any[];
	statusKey: string;
	renderComponent(data: any): any;
	changeEvent?(id: any, key: string): void;
	extractKey?(obj: any): string;
}

const Kanban = (props: IProps) => {
	const [data, setData] = useState<any>({});
	const [keys, setKeys] = useState<string[]>([]);
	const [startColumn, setStartColumn] = useState<any>({});
	const [endColumn, setEndColumn] = useState<any>({});

	const setDataColumn = (dataColumn: any[], key: string) => {
		if (dataColumn.length > data[key].length) {
			setStartColumn({ key, data: [...dataColumn] });
		}
		if (dataColumn.length < data[key].length) {
			setEndColumn({ key, data: [...dataColumn] });
		}

		if (dataColumn.length > data[key].length) {
			var changedItem = dataColumn.find(
				(item) => item[props.statusKey].name != key
			);
			if (props.changeEvent) props.changeEvent(changedItem, key);
		}
	};

	useEffect(() => {
		if (!props.columnsData) setKeys(Object.keys(data));
		else setKeys(props.columnsData);
	}, [data]);

	useEffect(() => {
		var eventData = { ...data };
		eventData[startColumn.key] = startColumn.data;
		eventData[endColumn.key] = endColumn.data;
		setData({ ...eventData });
	}, [endColumn]);

	useEffect(() => {
		var eventData: any = {};
		for (let t of props.columnsData) eventData[t] = [];
		for (var el of props.data) {
			var k = undefined;
			if (props.extractKey) k = props.extractKey(el);
			else k = props.statusKey;
			if (!eventData[k]) eventData[k] = [];
			eventData[k].push(el);
		}
		setData(eventData);
	}, [props.data]);

	return (
		<div className="flex w-full gap-10 overflow-auto">
			{keys.map((el: string, i: number) => (
				<Column
					data={data[el] ? data[el] : []}
					setData={setDataColumn}
					columnKey={el}
					className={props.columnClassName}
					key={`canban-col-${i}`}
					index={i}
				>
					{data[el].map((item: any) => props.renderComponent(item))}
				</Column>
			))}
		</div>
	);
};

export default Kanban;
